/*
 * This is an intermediate bug fix for this angular bug
 * https://github.com/angular/angular/issues/12334
*/

import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'ngDatePipeFix',
})
export class NgDatePipeFix implements PipeTransform {

    transform(value: any, ...args: any[]): Date {
        return this.fix(value);
    }

    private fix(value: any): Date {
        const fixedDate = value ? moment(value).toDate() : undefined;
        return fixedDate;
    }

}
